<script setup>
import { computed, ref } from 'vue'
import { useMeta } from '@/stores/meta.js'
import { useSession } from '@/stores/session.js'
import DictionaryEditor from '@/components/settings/DictionaryEditor.vue'

/**
 * By the label of a field whose list comes from a dictionary (D-136): says so — the list is
 * the company's and can be changed — and lets whoever manages dictionaries edit it there.
 */
const props = defineProps({ dictionary: { type: String, required: true } })
const meta = useMeta()
const session = useSession()
const editing = ref(false)
const name = computed(() => meta.localized(meta.dictionary(props.dictionary).label) || props.dictionary)
const canEdit = computed(() => session.has('dictionary:manage'))
</script>

<template>
  <span class="inline-flex">
    <button v-if="canEdit" type="button" class="rounded px-1 text-2xs text-faint hover:text-brand-600" :title="$t('dictionaries.editHint', { name })" :aria-label="$t('dictionaries.editHint', { name })" :data-testid="`dictionary-badge-${dictionary}`" @click.prevent.stop="editing = true">
      <i class="fa-solid fa-book" aria-hidden="true"></i>
    </button>
    <span v-else class="px-1 text-2xs text-faint" :title="$t('dictionaries.hint', { name })"><i class="fa-solid fa-book" aria-hidden="true"></i></span>
    <DictionaryEditor v-if="canEdit" :open="editing" :dictionary-key="dictionary" @close="editing = false" @saved="editing = false" />
  </span>
</template>
